import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeftIcon } from "../icons";

function Breadcrumb(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const backButtonColor = "#1c4c94";
  const showBack = Boolean(props.backLink || props.onBack);

  const hideTitle = Boolean(props.hideTitle);
  const showLeftCol = !hideTitle;

  const handleBack = () => {
    if (props.onBack) {
      props.onBack();
      return;
    }
    if (props.backLink) {
      navigate(props.backLink);
      return;
    }
    navigate(-1);
  };
  return (
    <div className="breadcrumb my-4">
      <Container>
        <Row>
          {showLeftCol && (
            <Col
              md={6}
              className="d-flex align-items-center justify-content-between justify-content-sm-start mb-2 mb-md-0 "
            >
              <div className="d-flex align-items-center">
                <div>
                  <h4
                    className=" page-title me-4 mb-0 font-lg d-flex align-items-center"
                    style={{ fontWeight: "600" }}
                  >
                    {showBack && (
                      <button
                        type="button"
                        onClick={handleBack}
                        className="btn btn-link p-0 me-2 d-inline-flex align-items-center"
                        style={{ textDecoration: "none", color: backButtonColor }}
                      >
                        <ArrowLeftIcon style={{ color: backButtonColor }} />
                        <span style={{ fontSize: "0.9rem", fontWeight: 600 }}>
                          {props.backLabel || t("button.back")}
                        </span>
                      </button>
                    )}
                    {props.icon}
                    {props.title}
                  </h4>
                </div>
              </div>
            </Col>
          )}

          <Col
            md={showLeftCol ? 6 : 12}
            className="d-flex justify-content-between mt-auto  justify-content-md-end gap-2 flex-wrap"
          >
            {props.weather && props.weather}
            {props.addButton && <div className="col-auto p-lg-0">{props.addButton}</div>}
            {props.addIrrigationButton && (
              <div className="col-auto p-lg-0">{props.addIrrigationButton}</div>
            )}
            {props.addTreeButton && <div className="col-auto p-lg-0">{props.addTreeButton}</div>}
            {props.viewType && <div className="col-auto ms-lg-4"> {props.viewType} </div>}
            {props.importButton && <div className="col-auto p-lg-0">{props.importButton}</div>}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default React.memo(Breadcrumb);
